import React, {useState, useEffect} from "react";
import { UrlPath } from "../../config/routeConfig";
import { BreadCrumbs } from "../shared/breadCrumbs/BreadCrumbs";
import { TopBar } from "../shared/topBar/TopBar";
import { ToastContainer } from "react-toastify";
import {getCustomSettings, updateCustomSettings} from "../../config/apiConfig";
import { sbaAxios } from "../utils/sbaAxios";

function Settings(){
    const Level = [{ BreadCrumb: "Settings", Routes: `${UrlPath.Settings}` }];
    const [userSettings, setUserSettings] = useState(null);
    const [userSettingsData, setUserSettingsData] = useState(null);

    const getUserSettings = async () => {
        try{
            const response = await sbaAxios({ url: `${getCustomSettings}1028` });
            if(response){
                const parsedResponse = JSON.parse(response.CustomSettingsValue);
                setUserSettings(parsedResponse);
                setUserSettingsData(parsedResponse);
            }
        }
        catch(e){
            setUserSettings(null);
        }
    };

    const updateUserSettings = async (updatedSettings) => {
        try{
            const saveData = {
                "componentId": 1028,
                "componentUserSettingId": 0,
                "userId": 0,
                "customSettingsValue": JSON.stringify(updatedSettings),
                "isGrid": false
              };
              sbaAxios({ url: updateCustomSettings, method: 'post', data: saveData }).then(res=>{
                window.location.reload();
              })
        }
        catch(e){

        }
    }
    const handleCheckboxChange = (key) => {
        setUserSettings((prevSettings) => {
            const newSettings = { ...prevSettings, [key]: !prevSettings[key] };
            // updateUserSettings(newSettings); // Call API immediately after state update
            return newSettings;
        });
    };
    useEffect(()=>{
        getUserSettings();
    },[])
    useEffect(()=>{
        console.log("userSettings: ", userSettings)
    },[userSettings]);
    useEffect(()=>{
        document.title="Settings";
    },[]);

    return <>
        <TopBar label={"Settings"} />
        <div className="mainContentData">
            <BreadCrumbs Levels={Level} />
            <div className="container-fluid p-4">
            <div className="row mb-2">
                        <div className="col">
                            <input 
                                type="checkbox" 
                                id="knowledgeBase" 
                                className="form-check-input" 
                                checked={userSettings?.knowledgeBase}
                                onChange={() => handleCheckboxChange("knowledgeBase")}
                            />
                            <label htmlFor="knowledgeBase" className="ms-2">Knowledge base/Profile in menu</label>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col">
                            <input 
                                type="checkbox" 
                                id="globalSearch" 
                                className="form-check-input" 
                                checked={userSettings?.globalSearch}
                                onChange={() => handleCheckboxChange("globalSearch")}
                            />
                            <label htmlFor="globalSearch" className="ms-2">Global Search Visible</label>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col">
                            <input 
                                type="checkbox" 
                                id="menuHover" 
                                className="form-check-input" 
                                checked={userSettings?.menuHover}
                                onChange={() => handleCheckboxChange("menuHover")}
                            />
                            <label htmlFor="menuHover" className="ms-2">Menu Hover Expand/Collapse</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <input 
                                type="checkbox" 
                                id="showIconsAsText" 
                                className="form-check-input" 
                                checked={userSettings?.showIconsAsText}
                                onChange={() => handleCheckboxChange("showIconsAsText")}
                                disabled
                            />
                            <label htmlFor="showIconsAsText" className="ms-2">Show icons as text</label>
                        </div>
                    </div>
                    <div className="my-4">
                    <button className="p-sm-btn mx-2" onClick={()=>{updateUserSettings(userSettings)}}>Save</button>
                    <button className="s-sm-btn mx-2" onClick={()=>{setUserSettings(val=>userSettingsData)}}>Cancel</button>
                    </div>
            </div>
        </div>
        <ToastContainer/>
    </>
}

export default Settings;